"use client";

import { useEffect, useRef } from "react";

import { usePathname } from "next/navigation";

export default function BodyClassManager(): null {
  const pathname = usePathname();
  const prevClassRef = useRef<string>("");

  useEffect(() => {
    const pageClass =
      pathname
        ?.replace(/^\/|\/$/g, "")
        .split("/")
        .join("-") || "index";

    // Remove previous page class
    if (prevClassRef.current && prevClassRef.current !== pageClass) {
      document.body.classList.remove(prevClassRef.current);
    }

    // Add new page class
    document.body.classList.add(pageClass);
    prevClassRef.current = pageClass;

    return () => {
      document.body.classList.remove(pageClass);
    };
  }, [pathname]);

  return null;
}
